export default "__VITE_ASSET__DoHN2rRq__"